module.exports = __webpack_public_path__ + "img/gy.4b697593.png";